import {call, put, takeLatest} from "redux-saga/effects";
import {getArtistToken} from "../../../auth/token.saga";
import {extractDataFromResponse} from "../../../saga-utils/httpInterceptorWrapper";
import {searchEinnahmen} from "../../../../api/terminApi";
import {
    LOAD_EINNAHMEN_LIST_DATA,
    loadEinnahmenListDataFailureAction,
    loadEinnahmenListDataSuccessAction
} from "../../listActions";
import {emitNotificationAction} from "../../../notification/notificationAction";
import {createErrorNotification} from "../../../../models/notification";
import i18next from "i18next";
import {i18_LIST} from "../../../../i18nReferences";
import { standardizeListParametersOfParameterObject } from "../../../utils/urlHelper";

function* processLoadEinnahmenListData({payload}) {
    try {
        const token = yield getArtistToken()
        if (token) {
            const parameters = payload.parameters
            const standardParameters = standardizeListParametersOfParameterObject(parameters)
            const projekte = extractDataFromResponse(yield call(searchEinnahmen, {token, parameters: standardParameters}))
            yield put(loadEinnahmenListDataSuccessAction(projekte))
        }
    } catch (err) {
        yield put(emitNotificationAction(createErrorNotification(i18next.t('LIST.LOAD_TERMIN_DATA_FAILED_INFO', {ns: i18_LIST}), 'loadTerminListData')))
        yield put(loadEinnahmenListDataFailureAction())
        console.log(err)
    }
}

export function* watchLoadEinnahmenListData() {
    yield takeLatest(LOAD_EINNAHMEN_LIST_DATA, processLoadEinnahmenListData)
}